import { createAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';

export interface RememberStatusChange {
    status: string;
}

export const rememberStatusChange = createAction<
    ActionType,
    RememberStatusChange
>(ActionType.COACHING__CA__REMEMBER_STATUS_CHANGE);
